import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { laptopScreen } from '../../assets/screens';
import { FontAwesome } from '../Bootstrap';

// eslint-disable-next-line import/no-anonymous-default-export
export default function ({ operator }) {
  const imageName = operator?.slides[operator?.currentIndex].url;
  const [image, setImage] = useState(null);

  window.currentView = operator?.slides[operator?.currentIndex].view;
  window.currentAlias = operator?.slides[operator?.currentIndex].alias;
  window.currentIndex = operator?.currentIndex;

  useEffect(() => {
    const fetchImage = async () => {
      try {
        const response = await import(`/public/imgs/${imageName}`);
        setImage(response.default);
      } catch (err) {
        console.error(err);
      }
    };

    fetchImage();
  }, [imageName]);

  const SlideStyles = styled('div')`
    width: 100%;
    height: 100%;
    border-radius: 6px;
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
  `;

  const SlideStylesWidthBackground = styled(SlideStyles)`
    cursor: pointer;
    background-image: url(${image});
  `;

  return (
    <ContainerStyles>
      <ClearBtn onClick={operator.clearCaptures}>
        <FontAwesome
          className="fa-solid fa-xmark"
          style={{ color: 'crimson' }}
        />
      </ClearBtn>
      <SlideStyles>
        <SlideStylesWidthBackground onClick={operator?.openCamera} />
      </SlideStyles>
    </ContainerStyles>
  );
}

const ClearBtn = styled('button')`
  all: unset;
  cursor: pointer;
  display: none;
`;

const ContainerStyles = styled('div')`
  width: 300px;
  height: 200px;
  margin: 0 auto;

  ${laptopScreen(`
    width: 55%;
  `)};
`;
